import * as React from "react";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { TextualHolding } from "../../../dto/TextualHolding";
import { HoldingsInformation } from "../../../dto/HoldingsInformation";
import { useLocalHoldingsBranch } from "./LocalHoldingsBranch";
import { useLanguage } from "../../Language";
import { TextualHoldings } from "./TextualHoldings";
import { Holdings } from "./Holdings";
import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export interface LocalCopiesProps {
  resource: ResourceDWR;
}
export const LocalCopies: React.FC<LocalCopiesProps> = ({ resource }) => {
  const { branchIdentifier: localHoldingsBranchId } = useLocalHoldingsBranch();
  const { translate } = useLanguage();
  const holdingsCutoff = 5;
  const allCopiesURL = `/resource/${resource.id}/copies`;

  const holdings = resource.holdingsInformations.filter((holding) => {
    return (
      localHoldingsBranchId &&
      holding.branchIdentifier === localHoldingsBranchId &&
      !holding.serialItem
    );
  });
  const textualHoldings = resource.textualHoldings.filter((holding) => {
    return (
      localHoldingsBranchId &&
      holding.branchIdentifier === localHoldingsBranchId
    );
  });
  const serialHoldings = resource.holdingsInformations.filter((holding) => {
    return (
      localHoldingsBranchId &&
      holding.branchIdentifier === localHoldingsBranchId &&
      holding.serialItem
    );
  });

  // Derive branch name from any of the holdings, if available
  const branchName =
    holdings[0]?.branchName ||
    textualHoldings[0]?.branchName ||
    serialHoldings[0]?.branchName ||
    null;

  const showCheckOtherLocations =
    localHoldingsBranchId &&
    [...resource.holdingsInformations, ...resource.textualHoldings].some(
      (holding) => holding.branchIdentifier !== localHoldingsBranchId
    );

  const allCopiesLink = (
    holdings: HoldingsInformation[] | TextualHolding[]
  ) => {
    return holdings.length > holdingsCutoff ? (
      <Button component={Link} to={allCopiesURL} className="allCopies">
        {translate("viewAllCopies")}
      </Button>
    ) : null;
  };

  return (
    <>
      {branchName && (
        <div style={{ marginBottom: 50, fontSize: "0.95em" }}>
          <Typography variant="h6" component={"h4"}>
            {translate("findOnShelf")} {translate("availability_at")}{" "}
            {branchName}
            {showCheckOtherLocations && (
              <span>
                <Button
                  component={Link}
                  to={allCopiesURL}
                  className="allCopies"
                >
                  {translate("availability_checkOtherLocations")}
                </Button>
              </span>
            )}
          </Typography>
          {textualHoldings.length > 0 && (
            <>
              <TextualHoldings
                holdings={textualHoldings.slice(0, holdingsCutoff)}
              />
              {allCopiesLink(textualHoldings)}
            </>
          )}
          {holdings.length > 0 && (
            <>
              <Holdings
                resource={resource}
                holdings={holdings.slice(0, holdingsCutoff)}
              />
              {allCopiesLink(holdings)}
            </>
          )}
          {serialHoldings.length > 0 && (
            <>
              <Holdings
                resource={resource}
                holdings={serialHoldings.slice(0, holdingsCutoff)}
              />
              {allCopiesLink(serialHoldings)}
            </>
          )}
        </div>
      )}
    </>
  );
};
